import { hairSrc } from "./faceReading.js";

const variant = (id, name, image, detail, length = "medium") => ({
  id,
  name,
  image,
  detail,
  length,
});

export const STYLE_FAMILIES = [
  {
    id: "women-bob",
    gender: "wanita",
    name: "Bob",
    summary: "Tiga bob catalog: lurus tanpa poni, ujung terbuka, dan ujung melengkung.",
    shapes: { oval: 5, oblong: 5, heart: 5, diamond: 4, square: 4, round: 3 },
    variants: [
      variant("women-bob-bobcut", "Bobcut", "snap-bobcut.jpg", "Bob dagu lurus tanpa poni.", "bob"),
      variant("women-bob-flippy", "Flippy Bob", "snap-flippy_bob.jpg", "Bob dengan ujung terbuka ke luar.", "bob"),
      variant("women-bob-bendy", "Bendy Bob", "snap-bendy_bob.jpg", "Bob dengan ujung yang melengkung lembut.", "bob"),
    ],
  },
  {
    id: "women-wave",
    gender: "wanita",
    name: "Gelombang & Ikal",
    summary: "Gelombang, ikal, dan rambut panjang dari catalog SnapEdit.",
    shapes: { round: 5, square: 5, heart: 5, oval: 5, diamond: 4, oblong: 4 },
    variants: [
      variant("women-wave-wavy", "Wavy 1", "snap-wavy.jpg", "Gelombang natural di sepanjang rambut."),
      variant("women-wave-curls", "Curls", "snap-curls.jpg", "Ikal sepanjang rambut, volume terkendali."),
      variant("women-wave-long", "Long", "snap-long.jpg", "Rambut panjang dengan sedikit gerakan di ujung.", "long"),
    ],
  },
  {
    id: "women-braid",
    gender: "wanita",
    name: "Kepang",
    summary: "Satu gaya kepang. Bukan layered dan bukan wolf.",
    shapes: { oval: 4, heart: 4, diamond: 4, oblong: 3, round: 3, square: 3 },
    variants: [
      variant("women-braid-classic", "Braided", "snap-braided.jpg", "Gaya kepang di atas rambut yang diikat ke belakang."),
    ],
  },
  {
    id: "women-bangs",
    gender: "wanita",
    name: "Poni",
    summary: "Poni catalog: penuh, air, dan sapuan kiri. Bukan curtain bangs.",
    shapes: { oval: 5, oblong: 5, heart: 5, diamond: 5, square: 4, round: 3 },
    variants: [
      variant("women-bangs-full", "Bangs", "snap-bang.jpg", "Poni penuh yang menutupi dahi."),
      variant("women-bangs-air", "Air", "snap-air_bang.jpg", "Poni air tipis dengan belahan tengah."),
      variant("women-bangs-left", "Left sweep", "snap-side_swept_bang_left.jpg", "Poni disapu ke kiri."),
    ],
  },
  {
    id: "men-texture",
    gender: "pria",
    name: "Tekstur catalog",
    summary: "Tiga gaya SnapEdit pada foto pria. Bukan crew, buzz, crop, atau potongan barber.",
    shapes: { oval: 5, oblong: 5, square: 4, heart: 4, diamond: 3, round: 3 },
    variants: [
      variant("men-texture-wavy", "Wavy 1", "snap-wavy.jpg", "Gelombang natural di sepanjang rambut."),
      variant("men-texture-curls", "Curls", "snap-curls.jpg", "Ikal sepanjang rambut, volume terkendali."),
      variant("men-texture-part", "Fix hair part", "snap-hair_part_fixing.jpg", "Merapikan belahan; potongan tetap dekat dengan rambut asli."),
    ],
  },
];

export const DISPLAYED_TOKEN_BY_VARIANT = {
  "women-bob-bobcut": "bobcut",
  "women-bob-flippy": "flippy_bob",
  "women-bob-bendy": "bendy_bob",
  "women-wave-wavy": "wavy",
  "women-wave-curls": "curls",
  "women-wave-long": "long",
  "women-braid-classic": "braided",
  "women-bangs-full": "bang",
  "women-bangs-air": "air_bang",
  "women-bangs-left": "side_swept_bang_left",
  "men-texture-wavy": "wavy",
  "men-texture-curls": "curls",
  "men-texture-part": "hair_part_fixing",
};

function familyScore(family, reading) {
  if (!reading) return 0;
  const primary = family.shapes?.[reading.shape] || 0;
  const secondary = family.shapes?.[reading.secondary] || 0;
  return primary * 2 + secondary;
}

let liveFamilies = STYLE_FAMILIES;

export function setStyleFamilies(families) {
  if (Array.isArray(families) && families.length) liveFamilies = families;
}

export function currentStyleFamilies() {
  return liveFamilies;
}

export function variantGridClass(count) {
  if (count <= 1) return "grid max-w-xs grid-cols-1 gap-3";
  if (count === 2) return "grid grid-cols-2 gap-3";
  if (count === 3) return "grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3";
  return "grid grid-cols-2 gap-3 lg:grid-cols-4";
}

export function recommendStyleFamilies(reading, gender = "wanita") {
  const families = liveFamilies
    .filter((family) => family.gender === gender)
    .sort((a, b) => familyScore(b, reading) - familyScore(a, reading) || a.name.localeCompare(b.name));
  const aiIds = reading?.aiFamilyIds || [];
  const aiPicked = aiIds.map((id) => families.find((family) => family.id === id)).filter(Boolean);
  return [...aiPicked, ...families.filter((family) => !aiPicked.includes(family))];
}

export function styleVariantImage(style) {
  if (style?.imageUrl) return style.imageUrl;
  return hairSrc(style?.image || "style-crop.jpg");
}

export function allStyleVariants() {
  return liveFamilies.flatMap((family) => family.variants || []);
}
